import { getDifferenceBetweenFirstAndLastValues, getFirstAndLastValues, getsumOfValues } from "@/utils/analytics/growthMetricsUtils"

export const linkedinFollowersGrowthConfig = [
    {
        plotName: "followers",
        metricName: "followers",
        sumMetrics: false,
        title: "analytics_growth.followers",
        helpText: "analytics_growth.total_number_of_followers",
        cssIcon: "fa-duotone fa-solid fa-users",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getFirstAndLastValues,
    },
    {
        plotName: "followers",
        metricName: "followers",
        sumMetrics: false,
        title: "analytics_growth.new_followers",
        helpText: "analytics_growth.users_who_followed_you_recently",
        cssIcon: "fa-duotone fa-solid fa-user-plus",
        cssIconColor: "#7239EA",
        showGrowthBadge: false,
        calculateFunction: getDifferenceBetweenFirstAndLastValues,
    },
]

export const linkedinPlatformsGrowthConfig = [
    {
        plotName: "impressions",
        metricName: "impressions",
        sumMetrics: false,
        title: "analytics_growth.impressions",
        helpText: "analytics_growth.total_number_of_impressions",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "impressions",
        metricName: "reach",
        sumMetrics: false,
        title: "analytics_growth.reach",
        helpText: "analytics_growth.total_unique_reach",
        cssIcon: "fa-duotone fa-solid fa-bullseye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "engagement",
        metricName: "reactions",
        sumMetrics: false,
        title: "analytics_growth.reactions",
        helpText: "analytics_growth.total_reactions_on_posts",
        cssIcon: "fa-duotone fa-solid fa-heart",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
        {
        plotName: "posts_per_day_plot",
        metricName: "posts_per_day_plot",
        sumMetrics: false,
        title: "analytics_growth.posts",
        helpText: "analytics_growth.total_number_of_posts_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-images",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    }
]
